import { render, staticRenderFns } from "./AdminBillingDetail.vue?vue&type=template&id=1bdc5c34&scoped=true"
import script from "./AdminBillingDetail.vue?vue&type=script&lang=js"
export * from "./AdminBillingDetail.vue?vue&type=script&lang=js"
import style0 from "./AdminBillingDetail.vue?vue&type=style&index=0&id=1bdc5c34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdc5c34",
  null
  
)

export default component.exports